import React, { Component } from 'react';
import './../../css/table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import detail from './../../img/details.png';
import moment from 'jalali-moment';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const MySwal = withReactContent(Swal);

export default class EduResumeList extends Component {
  constructor() {
    super();
    this.state = {
      posts: [],
      search:'',
      filterPosts:[],
      fromDate: '',
      toDate: '',
      isFilter: false,
      postsLength: null,
      filteredLength: null
    };
  }
  componentDidMount() {
    this.getPost();
  }

  downloadResume(resume_id) {
    window.open(`https://arianapars-dashboard.ap-immigration.ir/app/resume-download/${resume_id}`);
  }

  fromDateHandler(value){
    this.setState({ fromDate: value})
  }
  toDateHandler(value){
    this.setState({ toDate: value})
  }

  filterByTime() {
    axios
      .post("https://arianaapp.arianaapply.com/panel/report/all-number-send-resumestudyopportunities", {
        startTime: moment(new Date(this.state.fromDate), "yyyy-mm-dd")
          .locale("en")
          .format("YYYY-MM-DD"),
        endTime: moment(new Date(this.state.toDate), "yyyy-mm-dd")
          .locale("en")
          .format("YYYY-MM-DD"),
      })
      .then((res) => {
        console.log("res", res);
        this.setState({isFilter: true, filterPosts: res.data.data[0], filteredLength: res.data.data[0].length})
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    return (
      <div className='index'>
        {this.state.posts.length > 0 ? (
          <div className='table'>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                margin: '1rem 0',
              }}>
              <input
                className='search-input'
                type='search'
                name='search'
                value={this.state.search}
                placeholder='جستجو کنید....'
                onChange={(e) => this.setState({ search: e.target.value })}
              />
            </div>
            <div className="time-filter">
            <h4>فیلتر بر اساس زمان:</h4>
            <div className="time-filter-inputs">
              <div style={{ direction: "rtl" }}>
                <label>از تاریخ:</label>
                <DatePicker
                  value={this.state.fromDate}
                  onChange={(v)=> this.fromDateHandler(v)}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-center"
                />
              </div>
              <div>
                <label>تا تاریخ:</label>
                <DatePicker
                  value={this.state.toDate}
                  onChange={(v)=> this.toDateHandler(v)}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-center"
                />
              </div>
            </div>
            <button
              className="success filter-date-btn"
              onClick={() => this.filterByTime()}
            >
              فیلتر
            </button>
            {this.state.isFilter && (
              <button
                className="danger filter-date-btn"
                onClick={()=> this.setState({isFilter: false})}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            )}
          </div>
          <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                margin: "1rem 0",
                fontSize: '20px'
              }}
            >
              <span>تعداد: {!this.state.isFilter ? this.state.postsLength : this.state.filteredLength}</span>
              </div>
            <table>
              <thead>
                <tr>
                  <td>#</td>
                  <td>نام</td>
                  <td>شهر</td>
                  <td>ایمیل</td>
                  <td>جنسیت</td>
                  <td>زبان</td>
                  <td>سن</td>
                  <td>تاهل</td>
                  <td>خدمت</td>
                  <td>شماره تماس</td>
                  <td>تاریخ</td>
                  <td>موقعیت تحصیلی</td>
                  <td>رزومه</td>
                </tr>
              </thead>
              <tbody>
                {
                  !this.state.isFilter ?
                this.state.posts.filter((p => p.resume.name.toLowerCase().includes(this.state.search))).map((item, i) => (
                  <tr key={item._id}>
                    <td>{i}</td>
                    <td>{item.resume.name}</td>
                    <td>{item.resume.city}</td>
                    <td>{item.resume.email}</td>
                    <td>{item.resume.gender}</td>
                    <td>{item.resume.language}</td>
                    <td>{item.resume.age}</td>
                    <td>{item.resume.maritalStatus}</td>
                    <td>{item.resume.militaryService}</td>
                    <td>{item.resume.phone}</td>
                    <td>
                      {
                        moment(item.resume.created_at, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')
                      }
                    </td>
                    <td>{item.studyopportunity.title}</td>
                    <td>
                      {' '}
                      <button
                        className='resume-detail-btn'
                        onClick={() => this.downloadResume(item.resume_id[0])}>
                        {' '}
                        <img className='detail-img' src={detail} alt='' />{' '}
                      </button>{' '}
                    </td>
                  </tr>
                )):
                this.state.filterPosts.map((item, i) => (
                  <tr key={item._id}>
                    <td>{i}</td>
                    <td>{item.name}</td>
                    <td>{item.city}</td>
                    <td>{item.email}</td>
                    <td>{item.gender}</td>
                    <td>{item.language}</td>
                    <td>{item.age}</td>
                    <td>{item.maritalStatus}</td>
                    <td>{item.militaryService}</td>
                    <td>{item.phone}</td>
                    <td>
                      {
                        moment(item.created_at, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')
                      }
                    </td>
                    <td>{item.title}</td>
                    <td>
                      {' '}
                      <button
                        className='resume-detail-btn'
                        onClick={() => this.downloadResume(item.resume_id[0])}>
                        {' '}
                        <img className='detail-img' src={detail} alt='' />{' '}
                      </button>{' '}
                    </td>
                  </tr>
                ))
                }
              </tbody>
            </table>
          </div>
        ) : (
          <Spinner animation='border' variant='primary' />
        )}
      </div>
    );
  }

  getPost() {
    axios
      .get('https://arianaapp.arianaapply.com/panel/list-all-resumestudyopportunities')
      .then((response) => {
        this.setState({ posts: response.data.reverse(), postsLength: response.data.length });
        console.log(response);
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  }
}
